import WidgetLoader from 'components/WidgetLoader';
import WidgetVariantLoader from 'components/WidgetVariantLoader';
import { DisplayUnitsProvider } from 'state/displayUnits/context';
import { PageDataProvider } from 'state/pageData';
import { SessionProvider } from 'state/session';
import { TextDirectionProvider } from 'state/textDirection';
import { TrackingProvider } from 'state/tracking';
import WidgetProvider from 'state/widget/context';

export interface AppProps {
  reactRoot: HTMLElement;
  sessionId?: string;
  title?: string;
  url?: string;
  widgetId: string;
  variantId?: string;
}

const App: React.FC<AppProps> = ({
  sessionId,
  reactRoot,
  title,
  url,
  variantId,
  widgetId,
}) => (
  <TextDirectionProvider>
    <WidgetProvider>
      <DisplayUnitsProvider>
        <PageDataProvider {...{ reactRoot, title, url, widgetId }}>
          <SessionProvider sessionId={sessionId}>
            <TrackingProvider>
              <WidgetLoader overrides={{ variantId }}>
                <WidgetVariantLoader />
              </WidgetLoader>
            </TrackingProvider>
          </SessionProvider>
        </PageDataProvider>
      </DisplayUnitsProvider>
    </WidgetProvider>
  </TextDirectionProvider>
);

export default App;
